// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"ba8b4b09ed73cccbd0e8","678":"12538aa0d4fb0c3c15f0","883":"1c2f4379b7bcbb6d6934"}[chunkId] + ".js";
};